import axios, { AxiosPromise } from 'axios';
import { OnRequestSuccess, OnRequestError, OnRequest, OnError } from '../services/Responses';
//import { ShowLoginModal } from '../components/Layout/GlobalLoginModal';

export class AbstractApiService {
    private baseUrl: string = 'https://logowanie.kif.info.pl/';

    protected HttpGet(url: string): AxiosPromise<any> {
        return axios.get(this.baseUrl + url, this.GetConfig());
    }

    protected HttpPost(url: string, data: any): AxiosPromise<any> {
        return axios.post(this.baseUrl + url, JSON.stringify(data), this.GetConfig());
    }

    protected Get(url: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.HttpGet(url).then(res => {
            onSuccess(res);
        }).catch(error => {
            onError(error);
        });
    }

    protected Post(url: string, data: any, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.HttpPost(url, data).then(res => {
            onSuccess(res);
        }).catch(error => {
            onError(error);
        });
    }

    protected GetTemplate<T, E>(url: string, onSuccess: OnRequest<T>, onError: OnError<E>): void {
        this.HttpGet(url).then(res => {
            onSuccess(res.data as T);
        }).catch(error => {
            if (error.response) {
                onError(error.response.status, error.response.data as E);
            }

        });
    }

    protected PostTemplate<T, E>(url: string, data: any, onSuccess: OnRequest<T>, onError: OnError<E>): void {
        this.HttpPost(url, data).then(res => {
            onSuccess(res.data as T);
        }).catch(error => {
            if (error.response) {
                onError(error.response.status, error.response.data as E);
            }

        });
    }

    private GetConfig(): any {
        let config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        return config;
    }
}



// WEBPACK FOOTER //
// ./src/abstractions/AbstractApiService.tsx